import DoppelgangerPage from "@faire/prototype-playground/workspace/th/doppelganger";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import { withCompass } from "../../components/compass/withCompass";
import LiveRoadmapDemoPage from "@faire/prototype-playground/workspace/th/live-roadmap-demo";

const AudreysBrandPage = withCompass(
  () => import("../../pages/AudreysBrandPage")
);
const BrandPageFaQsPage = withCompass(
  () => import("../../workspace/th/brand-page-faqs/Page")
);
const BrandAnalyticsColorExplorerPage = lazy(
  () => import("../../pages/BrandAnalyticsColorExplorerPage")
);
const DesignFaireComV2Page = lazy(
  () => import("../../pages/DesignFaireComV2Page")
);
const PasswordGate = lazy(
  () => import("../../pages/design-faire-com-v2/PasswordGate")
);
const PostNormalPage = lazy(
  () => import("../../pages/design-faire-com-v2/PostNormalPage")
);
const PostPlaygroundPage = lazy(
  () => import("../../pages/design-faire-com-v2/PostPlaygroundPage")
);

export function TimHooverRoutes() {
  return (
    <Switch>
      <Route
        path="/th/design-faire-com-v2/posts/normal-example"
        render={() => (
          <PasswordGate>
            <PostNormalPage />
          </PasswordGate>
        )}
      />
      <Route
        path="/th/design-faire-com-v2/posts/playground"
        render={() => (
          <PasswordGate>
            <PostPlaygroundPage />
          </PasswordGate>
        )}
      />
      <Route
        path="/th/design-faire-com-v2"
        render={() => (
          <PasswordGate>
            <DesignFaireComV2Page />
          </PasswordGate>
        )}
      />
      <Route path="/th/brand/audreys-home-gift" component={AudreysBrandPage} />
      <Route
        path="/th/brand-analytics-colors"
        component={BrandAnalyticsColorExplorerPage}
      />
      <Route path="/th/brand-page-faqs" component={BrandPageFaQsPage} />
      <Route path="/th/doppelganger" component={DoppelgangerPage} />
      <Route path="/th/live-roadmap-demo" component={LiveRoadmapDemoPage} />
    </Switch>
  );
}

export const slug = "th";
